export const extractDomain = (url: string): string | null => {
  try {
    // Ensure URL has a protocol
    let fullUrl = url;
    if (!url.match(/^https?:\/\//)) {
      fullUrl = 'https://' + url;
    }
    
    const hostname = new URL(fullUrl).hostname;
    
    // Remove www. prefix if present
    const cleanHostname = hostname.replace(/^www\./, '');
    
    // Split into parts and get the domain
    const parts = cleanHostname.split('.').reverse();
    if (parts.length >= 2) {
      return `${parts[1]}.${parts[0]}`;
    }
    return cleanHostname;
  } catch (error) {
    // If URL parsing fails, try to extract domain using regex
    try {
      const match = url.match(/(?:https?:\/\/)?(?:www\.)?([^\/\s]+)/);
      if (match && match[1]) {
        const hostname = match[1];
        const parts = hostname.split('.').reverse();
        if (parts.length >= 2) {
          return `${parts[1]}.${parts[0]}`;
        }
        return hostname;
      }
    } catch (e) {
      // Fallback - return null if we can't extract anything
    }
    return null;
  }
};